import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	getDocumentListAction,
	deleteDocumentAction,
	resetInvoicingError,
	resetInvoiceStatusCode,
	resetInvoicingSuccess,
} from '../../redux/invoicing'
import { resetSession } from '../../redux/auth';
import { UserIcon } from '../../components/Icon';
import { CommonHeader, Loader, ErrorSuccessModal } from '../../components/commons';
import { EmptyPage } from '../../assets/images';
import DocumentTable from '../../components/DocumentTable';
import SingleUpload from '../../components/commons/Upload/SingleUpload';
import { DOCUMENT_LIST_HEADER } from '../../constant/tableHeadersConstants/documentHeaderConst';
import {UploadModal} from '../../components/commons';

interface Props {
	history?: any;
	error?: any;
	token: string;
	statusCode: any;
	documentList: any;
	success: any;
	message: string | null;
	fetching: boolean;
	dispatchGetDocumentListAction: Function;
	dispatchResetInvoicingError: Function;
	dispatchDeleteDocumentAction: Function;
	dispatchResetSession: Function;
	dispatchResetInvoicingSuccess: Function;
	dispatchResetInvoiceStatusCode: Function;

}

const DocumentList = ({
	success,
	fetching,
	statusCode,
	history,
	token,
	error,
	message,
	documentList,
	dispatchResetInvoiceStatusCode,
	dispatchDeleteDocumentAction,
	dispatchResetSession,
	dispatchResetInvoicingSuccess,
	dispatchResetInvoicingError,
	dispatchGetDocumentListAction }: Props) => {
	// const client_code = history && history.location && history.location.state && history.location.state.client_code ? history.location.state.client_code : 0;

	const client_code = history?.location?.state?.client_code ? history?.location?.state?.client_code : 0;

	const {
		location: {
			state: {
				company_name = ''
			}
		}
	} = history

	const [searchState, setSearchState] = useState(false)
	const [modal, toggleModal] = useState(false)

	useEffect(() => {

		let data = {
			client_code,
			offset: 0,
			limit: 10,
			token
		}
		dispatchGetDocumentListAction(data)
		dispatchResetInvoicingError();
		dispatchResetInvoicingSuccess();
	}, [])

	function EmptyDocumentData() {
		return (
			<div >
				<h1 className="text-center">
					No documents found!
				</h1>
				<div className="text-center">
					<span className="sub-text">Start adding your documents by clicking on the below button.</span>
					<div className="mt-3">
						{/* <SingleUpload
							client_code={client_code}
							token={token}
							fetchNewData={fetchNewData}
							showButton={documentList?.total_count === 0}
						/> */}
						<button
							className="btn btn-primary"
							onClick={showUploadModal}
						>
							+ Upload Documents
						</button>
					</div>
					<div className="text-center pl-5 ml-5">
						<img src={EmptyPage} />
					</div>

				</div>
			</div>
		)
	}


	const fetchNewData = (offset?: number, limit?: number, search?: string) => {
		if (token) {

			if (search) setSearchState(true);

			let finalData = {
				token,
				client_code,
				offset: offset || 0,
				limit: limit || 10,
				search_term: search || ''
			}
			dispatchGetDocumentListAction(finalData);
		}
		dispatchResetInvoicingError();
		dispatchResetInvoicingSuccess();
	}

	const handleCallResetSessionFunctions = () => {
		dispatchResetInvoiceStatusCode();
		dispatchResetSession();
	}

	const handleErrorModal = () => {
		if (success === 0) {
			if (statusCode === 401) {
				return (
					<ErrorSuccessModal
						type="error"
						isOpen={!!error}
						title="Error"
						message="Session Expired"
						buttonText="Logout"
						onPress={() => handleCallResetSessionFunctions()}
						statusCode={statusCode}
					/>
				)
			} else if (error && statusCode !== 401) {
				return (
					<ErrorSuccessModal
						type="error"
						isOpen={!!error}
						title="Error"
						message={error}
						buttonText="OK"
						onPress={() => dispatchResetInvoicingError()}
					/>
				)
			}
		}

		if (success === 1) {
			return (
				<ErrorSuccessModal
					type="success"
					isOpen={success === 1}
					title="Success"
					message={message || "Document Added Successfully!"}
					buttonText="OK"
					onPress={() => {
						fetchNewData();
						dispatchResetInvoicingSuccess();
					}}
					statusCode={statusCode}
				/>
			)
		}

		return false;
	}

	const showUploadModal = () => {
		toggleModal(!modal)
	}

	const deleteEntry = (id: any) => {

		let data = {
			token,
			document_id: id
		}
		dispatchDeleteDocumentAction(data)
	}

	return (
		<div className="row">
			<div className="col-md-6 mb-3">
				<CommonHeader title="All Documents" />
				<div className="d-flex align-items-center">
					{client_code ? <>
						<UserIcon /> &nbsp;
						{company_name}  {"(" + client_code + ")"}</> : null}
				</div>
			</div>
			<div className="col-md-6">
				<div className="d-flex flex-row justify-content-end mr-5">

					<button
						className="btn btn-primary"
						onClick={showUploadModal}
					>
						+ Upload Documents
					</button>

					{modal ? <UploadModal
						modal={modal}
						toggleModal={showUploadModal}
						client_code={client_code}
						token={token}
						fetchNewData={fetchNewData}
					/> : null}

				</div>
			</div>

			<div className="col-md-12 mt-4">
				<div className="content-area">
					{/* 	{
						documentList?.total_count === 0 && !searchState
							? <EmptyDocumentData /> :
							<DocumentTable
								data={documentList?.data}
								count={documentList?.total_count}
								fetchNewData={fetchNewData}
								// editInvoice={editInvoice}
								deleteEntry={deleteEntry}
								// downloadInvoice={downloadInvoice}
								fetching={fetching}
								type='expenses'
								client_code={client_code}
								history={history}
								tableHeader={DOCUMENT_LIST_HEADER}
							/>
					} */}
				</div>
			</div>
			{fetching && <Loader />}
			{handleErrorModal()}
		</div>
	)
}

const mapStateToProps = (state: any) => ({
	token: state.auth.token,
	fetching: state.invoicing.fetching,
	error: state.invoicing.error,
	success: state.invoicing.success,
	statusCode: state.invoicing.statusCode,
	documentList: state.invoicing.documentList,
	message: state.invoicing.message
})

const mapDispatchToProps = (dispatch: any) => ({
	dispatchResetSession: () => dispatch(resetSession()),
	dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
	dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
	dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess()),
	dispatchGetDocumentListAction: (data: any) => dispatch(getDocumentListAction(data)),
	dispatchDeleteDocumentAction: (data: any) => dispatch(deleteDocumentAction(data)),

})

export default connect(mapStateToProps, mapDispatchToProps)(DocumentList)